module.exports = __webpack_public_path__ + "img/sewerz.7034faae.jpg";